import { FormattedMessage } from 'react-intl';
import React, { ReactNode } from 'react';
import { BusinessStatusEnum } from './BusinessStatusEnum';
import TransactionInfoMessage from './TransactionInfoMessage';
import { TransactionInfoDetailsProps } from './TransactionInfoDetails';

type StatusContentProps = {
  normalizedTransactionStatus: BusinessStatusEnum;
  icon: ReactNode;
} & Pick<TransactionInfoDetailsProps, 'labelType'>;

export default function StatusContent({
  normalizedTransactionStatus,
  labelType,
  icon,
}: StatusContentProps) {
  return (
    <>
      <div className="status">
        <div className={`status ${normalizedTransactionStatus.toLowerCase()}`}>
          {icon}
        </div>
        <div className="statusLabel">
          <FormattedMessage id={`status.${normalizedTransactionStatus}`} />
        </div>
      </div>
      <div>
        <TransactionInfoMessage
          labelType={labelType}
          values={{ hasDays: false }}
        />
      </div>
    </>
  );
}
